module.exports = __webpack_public_path__ + "img/make-friends-party_ar.13b1d225.png";